/* GNW Selbst gestalten (2026-09-30): Prueft den optionalen Bild-Upload clientseitig
   (Dateityp, Groesse) und zeigt den gewaehlten Dateinamen an. Pflichtfelder und
   Auswahlanzeige uebernimmt assets/gnw-order-fields.js. Kein externer Dienst. */
(() => {
  'use strict';
  if (window.__gnwSelfDesign) return;
  window.__gnwSelfDesign = true;
  const allowed = ['image/jpeg', 'image/png', 'application/pdf'];
  const allowedExt = /\.(jpe?g|png|pdf)$/i;

  function formatSize(bytes) {
    return (bytes / (1024 * 1024)).toFixed(1).replace('.', ',') + ' MB';
  }

  function validate(field, input) {
    const status = field.querySelector('[data-gnw-upload-status]');
    const clear = field.querySelector('[data-gnw-upload-clear]');
    const maxMb = parseFloat(field.dataset.maxMb || '20');
    const file = input.files && input.files[0];
    let message = '';
    if (file) {
      const typeOk = allowed.includes(file.type) || allowedExt.test(file.name);
      if (!typeOk) message = 'Bitte lade eine JPG-, PNG- oder PDF-Datei hoch.';
      else if (file.size > maxMb * 1024 * 1024) message = 'Die Datei ist zu groß (maximal ' + maxMb + ' MB).';
    }
    input.setCustomValidity(message);
    if (status) {
      status.textContent = message || (file ? 'Ausgewählt: ' + file.name + ' (' + formatSize(file.size) + ')' : '');
      status.classList.toggle('is-error', Boolean(message));
    }
    if (clear) clear.hidden = !file;
    return !message;
  }

  function setup(field) {
    if (field.dataset.gnwSelfDesignReady) return;
    field.dataset.gnwSelfDesignReady = 'true';
    const input = field.querySelector('[data-gnw-upload]');
    const clear = field.querySelector('[data-gnw-upload-clear]');
    if (!input) return;
    input.addEventListener('change', () => {
      if (!validate(field, input)) input.reportValidity();
    });
    if (clear) {
      clear.addEventListener('click', () => {
        input.value = '';
        validate(field, input);
        input.focus();
      });
    }
  }

  function init(root = document) {
    root.querySelectorAll('[data-gnw-self-design]').forEach(setup);
  }

  document.addEventListener('submit', event => {
    const field = event.target.querySelector?.('[data-gnw-self-design]');
    if (!field || field.disabled) return;
    const input = field.querySelector('[data-gnw-upload]');
    if (input && !validate(field, input)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.reportValidity();
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
